/*
 * BottomBarItem
 * @module BottomBar
 * @flow
 */

import styled from 'styled-components/macro';
import { palette } from 'styled-theme';

import { Tab } from '~/components/Tabs/components/Tab';
import { type TabProps } from '~/components/Tabs/components/Tab/Tab';

export type BottomBarProps = TabProps & {
  palette?: string,
  onClick?: () => void,
};

const baseColor = palette('grayscale', 0, true);

export const BottomBarItem = styled(Tab)`
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: ${baseColor};
  flex-direction: column;
  font-size: 10px;
  justify-content: center;
  opacity: 0.8;

  &:hover {
    color: ${baseColor};
  }

  &.react-tab {
    padding: 0;
    flex: 1;
  }

  &.react-tab + .react-tab {
    margin-left: 0;
  }

  .react-tab-icon {
    margin-right: 0;
    margin-bottom: 4px;
  }

  &.react-tab__active {
    background-color: ${palette(2)};
    border-bottom-color: ${baseColor};
    color: ${baseColor};
    opacity: 1;

    .react-tab-icon {
      margin-top: 2px;
    }
  }

  svg {
    color: ${baseColor};
  }
`;

BottomBarItem.defaultProps = {
  palette: 'primary',
  testid: 'bottom-bar-item',
  onClick: () => {},
};
